<template>
  <div class="all_box" v-if="list.length>0">
    <div class="all_title">
      {{$t('base.like')}}
      <router-link :to="{path:'/market?type=like'}" target="_blank">{{$t('base.seeAll')}}</router-link>
    </div>
    <div class="all_box">
      <div class="swiper_box_list">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide class="like_slide" v-for="(item,index) in list" :key="index">
            <div class="slide_box">
              <div class="icon_vault" v-if="item.IsValut" ></div>
              <!-- <span class="favorite" @click="favorite(item)" :class="item.IsAttention?'on':''" v-if="userInfo != null"></span> -->
              <router-link :to="{path:'/carddetails/'+item.ID}" target="_blank">
                <div class="like_box">
                  <el-image class="like_img" :src="item.TitImg" fit="contain">
                    <img slot="error" src="../../../static/images/noimg.svg" class="el-image__inner" style="object-fit: contain;">
                  </el-image>
                </div>
                <div class="slide_txt">
                  <p class="line_txt3" :title="item.Title">{{item.Title}}</p>
                  <div class="price">{{areaSymbol}} {{item.USD_LowestPrice}}</div>
                  <!-- <span class="fare">$ {{item.yunfei}} Shipping</span> -->
                  <div class="bids_box">
                    <span v-if="item.ByWay!=1" class="icon_auction" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{item.OutCount}} {{item.OutCount != 1?$t('base.bids'):$t('base.bid')}}</span>
                    <span v-else class="icon_flash" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{$t('base.buyNow')}}</span>
                    <span v-if="item.ByWay!=1" class="icon_hour" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{ CountDown(item.EffectiveDate)}}</span>
                  </div>
                </div>
              </router-link>
            </div>
          </swiper-slide>
        </swiper>
        <div class="list_prev list_prev_like" slot="button-prev"></div>
        <div class="list_next list_next_like" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';
import { countDown, getInfo, setUTC, setAttention, titleSubstring } from "@/api/public";

export default {
  name: 'likeswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      timer: "",
      userInfo: '',
      areaSymbol: this.$store.state.areaSymbol,
      nowData: new Date().getTime(),
      list: '',
      SeachJson: [{ "Key": "Status", "Value": 1 }],
      sort: 'LastOnTimeStamp',
      sortType: 'DESC',
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 18,
        slidesPerGroup: 6,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.list_next_like',
          prevEl: '.list_prev_like'
        },
      }
    }
  },

  created() {
    this.userInfo = getInfo();
    this.getDetailList()
    this.cardTimer();
  },
  filters: {
    titleVal(data) {
      /* 商品列表标题截取 */
      return titleSubstring(data);
    }
  },
  methods: {
    favorite(obj) {
      let id = obj.ID;
      obj.IsAttention = !obj.IsAttention;
      setAttention(id, 0)
    },
    // status 0:错误，1:正常
    getDetailList(status) {
      let that = this;
      let SeachJson = JSON.stringify(that.SeachJson);
      let SeachJson2=[{"Key":"Status","Value":1},{"Key":"ByWay","Value":"2"}];
      let data = { userId: '', pageIndex: '1', pageSize: '9', searchJson: SeachJson, sort: that.sort, sortType: that.sortType }

      //console.log(data,status,'getDetailList')
      let wordList = window.localStorage.getItem('chyword') != null||window.localStorage.getItem('chyword') != undefined ? window.localStorage.getItem('chyword') : null;
      wordList = wordList!=null?JSON.parse(wordList):null;

      //console.log(wordList,status,'wordList')
      if(wordList!=null){
        data.searchKey=wordList[0]
      //console.log(data,status,'wordList')
      }else{
        data.searchJson=JSON.stringify(SeachJson2)
      //console.log(data,status,'wordList null')
      }

      // 当第一次拉取的数据不足6条，按价格高到低重新拉一遍
      if(status==0){
        if(data.searchKey){
          const { searchKey, ...newData } = data;
          data=newData
        }
        data.searchJson=JSON.stringify(SeachJson2)
      //console.log(data,status,'status')
      }
      if (that.userInfo != null) {
        data.userId = that.userInfo.MappingUserId
      //console.log(data,status,'userInfo')
      }
      console.log(this.$interface.OnSaleSearchCommodity, data)
      this.$post(this.$interface.OnSaleSearchCommodity, data).then(res => {
        if (res.result != 0) {
          var item = res.data;
          that.list = item.PagedMarketItemList
        }
      })

      //SearchCommodity 废弃
      // this.$get(this.$interface.SearchCommodity, data).then(res => {
      // //console.log(data,status,'SearchCommodity')
      //   if (res.result != 0) {
      //     var item = res.data;
      //     that.list = item.PagedMarketItemList
      //     // if(item.TotalCount>=6){
      //     //   that.list = item.PagedMarketItemList;
      //     // }else{
      //     //   if(data.searchKey){
      //     //     that.list = item.PagedMarketItemList;
      //     //   }else{
      //     //     that.getDetailList(0)
      //     //   }
      //     // }
      //   }
      // })
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
  },
  destroyed() {
    clearInterval(this.timer);
  }
}

</script>
<style scoped>
@import "../../../static/css/goodslist.css";

.line_txt3 {
  height: 54px;
  margin-bottom: 6px;
}

.like_slide {
  width: 184px;
  /* height: 302px; */
}

.like_slide .slide_box {
  /* height: 300px; */
  /* margin-top: 1px; */
  margin-left: 1px;
}

.slide_txt p {
  line-height: 1.3;
}

.like_img {
  background: #f7f7f7;
}

.slide_txt .on {
  text-decoration: underline;
}

.swiper_box_list .slide_box{
  margin-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/like.vue